import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
/**
 * 用户信息
 */

const useAuthStore = create()(
  persist(
    (set) => ({
      userInfo: null,
      setUserInfo: (userInfo) => set({ userInfo }),
    }),
    {
      name: "user-storage", // name of item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useAuthStore;
